import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInviteUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2938_3996)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M4.98438 17.1016V19.1016",
				stroke: "white",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.9844 17.1016V19.1016",
				stroke: "white",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8 9C9.65685 9 11 7.65685 11 6C11 4.34315 9.65685 3 8 3C6.34315 3 5 4.34315 5 6C5 7.65685 6.34315 9 8 9Z",
				stroke: "white",
				strokeWidth: 2,
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2 15V20L14.03 20.03L14.01 14.99C14.01 13.34 12.66 12 11.01 12H5C3.34 12 2 13.34 2 15Z",
				stroke: "white",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20 10V14",
				stroke: "white",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22 12H18",
				stroke: "white",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "bevel"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2938_3996",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgInviteUser;
